<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Xem chi tiết quyết định tịch thu/ xác lập đã gửi lên</strong>
                    </div>
                    <div class="document-view">
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Số QĐ tịch thu/ xác lập:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetConfiscateDecisions.decisionNumber" :title="assetConfiscateDecisions.decisionNumber" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Loại quyết định:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetConfiscateDecisions.decisionType == 1 ?'Tịch thu' : 'Xác lập'" :title="assetConfiscateDecisions.decisionType == 1 ?'Tịch thu' : 'Xác lập'" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Ngày quyết định: "
                                              label-for="unit"
                                              class="text-1"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetConfiscateDecisions.decisionDate | formatDate" :title="assetConfiscateDecisions.decisionDate | formatDate
                                                  " :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Nguồn gốc tài sản:"
                                              label-for="address"
                                              class="text-1"
                                              :label-cols="4"
                                              label-align="left"
                                              :horizontal="true">
                                    <b-form-input :value="assetConfiscateDecisions.assetSourceName" :title="assetConfiscateDecisions.assetSourceName" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Chức danh người QĐ:"
                                              label-for="region"
                                              class="text-1"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetConfiscateDecisions.decider" :title="assetConfiscateDecisions.decider" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Thuộc Bộ/ Tỉnh:"
                                              label-for="region"
                                              class="text-1"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetConfiscateDecisions.issuedUnitName" :title="assetConfiscateDecisions.issuedUnitName" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Tên vụ việc:"
                                              label-for="region"
                                              class="text-1"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetConfiscateDecisions.decisionName" :title="assetConfiscateDecisions.decisionName" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Đơn vị tạo:"
                                              label-for="region"
                                              class="text-1"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetConfiscateDecisions.unitName" :title="assetConfiscateDecisions.unitName" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Tổng giá trị tịch thu/ xác lập:"
                                              label-for="region"
                                              class="text-1"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetConfiscateDecisions.totalValue | currency" :title="assetConfiscateDecisions.totalValue | currency" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Ghi chú:"
                                              label-for="region"
                                              class="text-1"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetConfiscateDecisions.notes" :title="assetConfiscateDecisions.notes" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            :dataUrl="gridUrl"
                            gridName="Danh sách Tài sản"
                            ref="assetDecision">
                        <template v-slot:cell(assetValue)="row">
                            {{ row.item.assetValue | currency }}
                        </template>
                        <template v-slot:cell(calculationUnitValue)="row">
                            {{ row.item.calculationUnitValue | formatNumber }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button v-if="authorize(['ViewAssetExploitationDocument'])"
                                          @click="showAssetDetail(row.item, row.index, $event.target)"
                                          size="sm" title="Xem" variant="info">
                                    Xem
                                </b-button>
                            </b-button-group>
                        </template>
                    </b-grid>
                    <b-row class="justify-content-center">
                        <b-button type="button" variant="secondary" :to="{ path: '.' }">Quay lại</b-button>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-modal :no-enforce-focus="true" :id="infoModal.id" :title="infoModal.title" size="xl" :hide-footer="false">
            <div class="document-view">
                <div v-if="assetInfo.assetGroupId == asset_type_vehicle">
                    <b-row>
                        <b-col sm="6">
                            <b-form-group label="Mã tài sản tại PM nghiệp vụ:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.syncId" :title="assetInfo.syncId" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Mã tài sản tại kho:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.code" :title="assetInfo.code" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Tên xe:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.assetTypeName" :title="assetInfo.assetTypeName" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Tên tài sản:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.assetName" :title="assetInfo.assetName" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Nhãn xe:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.brandName" :title="assetInfo.brandName" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Đơn vị tính:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.calculationUnitType" :title="assetInfo.calculationUnitType" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Tổng GT tịch thu/ xác lập:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.assetValue | currency" :title="assetInfo.assetValue | currency" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Biển kiểm soát:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.vehicleRegistrationPlateNumber" :title="assetInfo.vehicleRegistrationPlateNumber" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6" v-if="assetInfo.assetGroupId == asset_type_vehicle">
                            <b-form-group label="Tải trọng:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.vehicleCapacity | formatNumber" :title="assetInfo.vehicleCapacity | formatNumber" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Số chỗ ngồi:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.vehicleSize | formatNumber" :title="assetInfo.vehicleSize | formatNumber" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Số cầu:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.vehicleNumberOfWheelDrivers" :title="assetInfo.vehicleNumberOfWheelDrivers" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <div v-if="assetInfo.assetGroupId == asset_type_other">
                    <b-row>
                        <b-col sm="6">
                            <b-form-group label="Mã tài sản tại PM nghiệp vụ:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.syncId" :title="assetInfo.syncId" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Mã tài sản tại kho:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.code" :title="assetInfo.code" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Loại tài sản:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.assetTypeName" :title="assetInfo.assetTypeName" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Tên tài sản:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.assetName" :title="assetInfo.assetName" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Đơn vị tính:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.calculationUnitType" :title="assetInfo.calculationUnitType" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="SL/KL/DT:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.calculationUnitValue | formatNumber" :title="assetInfo.calculationUnitValue | formatNumber" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Tổng GT tịch thu/ xác lập:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.assetValue | currency" :title="assetInfo.assetValue | currency" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <div v-if="assetInfo.assetGroupId == asset_type_house">
                    <b-row>
                        <b-col sm="6">
                            <b-form-group label="Mã tài sản tại PM nghiệp vụ:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.syncId" :title="assetInfo.syncId" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Mã tài sản tại kho:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.code" :title="assetInfo.code" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Cấp nhà:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.assetTypeName" :title="assetInfo.assetTypeName" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Tên nhà:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.assetName" :title="assetInfo.assetName" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Địa chỉ:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left"
                                          v-if="!assetInfo.landAddress">
                                <b-form-input :value="assetInfo.houseAddress" :title="assetInfo.houseAddress" :readonly="true"></b-form-input>
                            </b-form-group>
                            <b-form-group label="Thuộc khuôn viên:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left"
                                          v-if="assetInfo.landAddress">
                                <b-form-input :value="assetInfo.landAddress" :title="assetInfo.landAddress" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Năm đưa vào sử dụng:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.houseBuiltYear" :title="assetInfo.houseBuiltYear" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Tổng GT tịch thu/ xác lập:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.assetValue | currency" :title="assetInfo.assetValue | currency" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Diện tích sàn sử dụng:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.houseAreaBuilding | formatNumber" :title="assetInfo.houseAreaBuilding | formatNumber" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Đơn vị tính:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.calculationUnitType" :title="assetInfo.calculationUnitType " :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <div v-if="assetInfo.assetGroupId == asset_type_land">
                    <b-row>
                        <b-col sm="6">
                            <b-form-group label="Mã tài sản tại PM nghiệp vụ:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.syncId" :title="assetInfo.syncId" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Mã tài sản tại kho:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.code" :title="assetInfo.code" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Loại đất:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.assetTypeName" :title="assetInfo.assetTypeName" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Địa chỉ:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.assetName" :title="assetInfo.assetName" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Tổng GT tịch thu/ xác lập:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.assetValue | currency" :title="assetInfo.assetValue | currency" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Diện tích:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.calculationUnitValue | formatNumber" :title="assetInfo.calculationUnitValue | formatNumber" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Đơn vị tính:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.calculationUnitType" :title="assetInfo.calculationUnitType" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <template #modal-footer="{ ok, cancel, hide }">
                <b-button type="button" variant="primary" @click="hideModal(infoModal.id)">
                    Đóng
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'NationalPublicAssetHandlingDetail',
        mixins: [mixins],
        data() {
            return {
                asset_type_land: 17,//đất
                asset_type_house: 18,//nhà
                asset_type_vehicle: 19,//xe
                asset_type_other: 20,//khác
                infoModal: {
                    id: 'detail-asset-modal',
                    title: '',
                    content: ''
                },
                gridUrl: 'data/confiscate-decisions-asset/' + this.$route.params.confiscateDecisionId,
                searchForm: {
                    filter: null
                },
                gridOptions: {
                    fields: [
                        { key: 'syncId', label: 'Mã tài sản tại PM nghiệp vụ', sortable: true, sortDirection: 'asc' },
                        { key: 'code', label: 'Mã tài sản tại kho', sortable: true, sortDirection: 'asc' },
                        { key: 'assetName', label: 'Tên tài sản', sortable: true },
                        { key: 'assetTypeName', label: 'Loại tài sản', sortable: true },
                        { key: 'calculationUnitValue', label: 'SL/ KL/ DT', sortable: true },
                        { key: 'calculationUnitType', label: 'Đơn vị tính', sortable: true },
                        { key: 'assetValue', label: 'Tổng giá trị tịch thu/ xác lập', sortable: true, tdClass: 'text-right' },
                    ],
                    sortBy: 'assetName',
                },
                assetConfiscateDecisions: {},
                assetInfo: {}
            }
        },
        computed: {
            confiscateDecisionId() {
                return this.$route.params.confiscateDecisionId;
            }
        },
        created() {
            this.loadConfiscateDecisionsDetail();
        },
        methods: {
            hideModal(id) {
                this.$root.$emit('bv::hide::modal', id)
            },
            showAssetDetail(item, index, button) {
                this.loadAsssetInfo(item.id);
                this.infoModal.title = `Xem chi tiết tài sản`;
                this.infoModal.content = item.errorMessage;
                this.$root.$emit('bv::show::modal', this.infoModal.id, button);
            },
            loadAsssetInfo(assetId) {
                var vm = this;
                return this.$services.get(`data/confiscate-decisions-national-public-asset/${assetId}`).done(data => {
                    vm.assetInfo = data;
                });
            },
            loadConfiscateDecisionsDetail() {
                var vm = this;
                return this.$services.get(`data/confiscate-decisions/${this.confiscateDecisionId}`).done(data => {
                    vm.assetConfiscateDecisions = data;
                });
            },
            formatArea(val) {
                return this.$options.filters.formatNumber(val) + ' m²';
            },
            formatVolume(val) {
                return this.$options.filters.formatNumber(val) + ' g';
            }
        },
        watch: {
            confiscateDecisionId() {
                return this.$route.params.confiscateDecisionId;
            }
        }
    }
</script>
<style scoped>
    ul {
        columns: 2;
        -webkit-columns: 2;
        -moz-columns: 2;
    }
</style>
